import client from '../../../shared/api/client';

export const fetchHoldChallenges = (team) =>
  client.get(`/teams/${team.id}/hold_challenges.json`).then((response) => response.data);

export const startHoldChallenge = (team, holdPositionId) =>
  client.post(`/teams/${team.id}/hold_challenges.json`, {
    hold_challenge: { hold_position_id: holdPositionId }
  }).then((response) => response.data);

export const withdrawHoldChallenge = (team, holdChallengeId) =>
  client.post(`/teams/${team.id}/hold_challenges/${holdChallengeId}/withdraw.json`)
    .then((response) => response.data);

export const challengerSideOf = (challenge) => ({
  id: challenge.id,
  role: 'challenger',
  respond_by: challenge.respond_by,
  overdue: challenge.overdue,
  other_position: challenge.challenged?.position,
  other_title: challenge.challenged?.title
});

export const holdChallengeErrorMessage = (error, fallback) =>
  error?.response?.data?.errors?.join(', ') || fallback;

export const formatRespondBy = (respondBy) =>
  new Date(respondBy).toLocaleString('en-US', {
    weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit'
  });

export const startedChallengeDescription = ({ challenger, challenged, respond_by: respondBy }) => (
  `H${challenger.position} ${challenger.title} is challenging H${challenged.position} ${challenged.title}. `
    + `H${challenged.position} must respond by ${formatRespondBy(respondBy)}.`
);

export const keepHoldChallenge = (team, holdChallengeId) =>
  client.post(`/teams/${team.id}/hold_challenges/${holdChallengeId}/keep.json`)
    .then((response) => response.data);

export const URGENT_WINDOW_MS = 6 * 60 * 60 * 1000;

const MINUTE_MS = 60 * 1000;
const HOUR_MS = 60 * MINUTE_MS;

export const msLeft = (respondBy, now) => new Date(respondBy).getTime() - now;

export const timeLeftLabel = (respondBy, now) => {
  const remaining = msLeft(respondBy, now);
  if (remaining <= 0) return 'Overdue';
  if (remaining < HOUR_MS) return `${Math.max(1, Math.floor(remaining / MINUTE_MS))}m left`;
  if (remaining < 48 * HOUR_MS) return `${Math.floor(remaining / HOUR_MS)}h left`;
  return `${Math.floor(remaining / (24 * HOUR_MS))}d left`;
};

export const isUrgent = (respondBy, now) => msLeft(respondBy, now) < URGENT_WINDOW_MS;

export const challengesUrgency = (challenges, now) => {
  if (challenges.length === 0) return 'idle';
  return challenges.some((challenge) => isUrgent(challenge.respond_by, now)) ? 'urgent' : 'warning';
};

export const soonestRespondBy = (challenges) => challenges
  .map((challenge) => challenge.respond_by)
  .sort((a, b) => new Date(a) - new Date(b))[0];
